import React from 'react';

const Contact = () => {
    return (
        <>
            {/* Contact Section */}
            <section id="contact" className="contact section">
                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2><i className="bi bi-envelope navicon"></i> Kontak</h2>
                </div>
                {/* End Section Title */}
                <div className="container" data-aos="fade-up" data-aos-delay={100}>
                    <div className="row gy-4">
                        <div className="col-lg-5">
                            <div className="info-wrap">
                                <div
                                    className="info-item d-flex"
                                    data-aos="fade-up"
                                    data-aos-delay={200}
                                >
                                    <i className="bi bi-geo-alt flex-shrink-0" />
                                    <div>
                                        <h3>Alamat</h3>
                                        <p>Jl.Agung Raya II,Gg.Pandawa III No 60, Lenteng Agung Jakarta Selatan</p>
                                    </div>
                                </div>
                                {/* End Info Item */}
                                <div
                                    className="info-item d-flex"
                                    data-aos="fade-up"
                                    data-aos-delay={300}
                                >
                                    <i className="bi bi-telephone flex-shrink-0" />
                                    <div>
                                        <h3>Telephone</h3>
                                        <p><a className='text-dark' target='_blank' rel="noreferrer" href='tel:087887190963'>087887190963</a></p>
                                    </div>
                                </div>
                                {/* End Info Item */}
                                <div
                                    className="info-item d-flex"
                                    data-aos="fade-up"
                                    data-aos-delay={400}
                                >
                                    <i className="bi bi-envelope flex-shrink-0" />
                                    <div>
                                        <h3>Email</h3>
                                        <p><a className='text-dark' target='_blank' rel='noreferrer' href='mailto:fajarsubhan9b@gmail.com'>fajarsubhan9b@gmail.com</a></p>
                                    </div>
                                </div>
                                {/* End Info Item */}
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="info-wrap">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d495.6850747284126!2d106.8395190638127!3d-6.331725081774111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69edc5d1644e45%3A0x7dae627d361bf7f4!2sCasa%20de%20Rya!5e0!3m2!1sid!2sid!4v1727886218903!5m2!1sid!2sid"
                                    width={450}
                                    height={450}
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    title='maps'
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>
                        </div>

                        {/* End Contact Form */}
                    </div>
                </div>
            </section>
            {/* /Contact Section */}
        </>
    )
}

export default Contact;